export default class ExcelExportButton {
  private readonly endpoint: string;
  private readonly form: HTMLFormElement;

  constructor(private readonly button: HTMLButtonElement) {
    const { endpoint, formSelector } = this.button.dataset;
    if (!endpoint || !formSelector) {
      this.button.style.display = 'none';
      throw new Error('Excel export button is missing required attributes');
    }

    this.endpoint = endpoint;
    this.form = document.querySelector(formSelector) as HTMLFormElement;

    this.bindExport();
  }

  static initAll(): void {
    Array.from(document.querySelectorAll<HTMLButtonElement>('.js-excelExport'))
      .map((element) => new ExcelExportButton(element));
  }

  private bindExport(): void {
    this.button.addEventListener('click', () => {
      const exportForm = document.createElement('form');
      exportForm.action = this.endpoint;
      exportForm.innerHTML = this.form.innerHTML;
      this.button.insertAdjacentElement('afterend', exportForm);
      exportForm.submit();
      exportForm.remove();
    });
  }
}
